module.exports = __webpack_public_path__ + "img/loading.33b0788f.svg";